import { render } from "./YachtPageSidebar.vue?vue&type=template&id=2cddaf62&scoped=true"
import script from "./YachtPageSidebar.vue?vue&type=script&lang=js"
export * from "./YachtPageSidebar.vue?vue&type=script&lang=js"

import "./YachtPageSidebar.vue?vue&type=style&index=0&id=2cddaf62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cddaf62"]])

export default __exports__